import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8afc2254&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./app.css?vue&type=style&index=0&id=8afc2254&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afc2254",
  null
  
)

export default component.exports